import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { countriesIcons } from '@/assets/countries/countries'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        values: {
            ...countriesIcons,
        },
    },
    theme: {
        themes: {
            light: {
                primary: '#2276b2',
                secondary: '#9E9E9E',
                accent: '#FFC107', //
                info: '#2196F3', //
                success: '#4caf50',
                warning: '#ffa000',

                error: '#C44536',
                onerror: '#FFFFFF',

                background: '#ffa000',
                onbackground: '#2276b2',

                surface: '#4caf50',
                onsurface: '#4caf50',

                // STATUS
                open: '#2276b2',
                inProgress: '#FFC107',
                closed: '#4caf50',

                positive: '#42b371',
                low: '#2685e3',
                medium: '#FFA630',
                high: '#FF5533',
                extraHigh: '#881600',
            },
        },
    },
})
